export default "__VITE_ASSET__BvBYQz9t__"